import random from 'lodash/random'
import times from 'lodash/times'

export const generateRandomString = (): string => {
  return times(20, () => random(35).toString(36)).join('')
}
